export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пайдаланушы табылмады"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Таңдау"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жабу"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Іздеу"])}
}